import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'alLineBreak'
})
export class AlLineBreakPipe implements PipeTransform {

  transform(text: string): string {
    if (!text || !text.length) { return text; }
    
    return text.replace(/(\\r\\n)|([\r\n])/gmi, '<br/>');
  }

}
